module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-15-821f056294c7de97ff0a2629630924d5.png";